import {defineStore} from 'pinia';
import {ModuleAutoBusiness} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import autoBusinessAPI from '@/apis/di/autoBusinessAPI';
const autoBusinessStore = new BaseDictionaryStore(autoBusinessAPI);
export const useAutoBusinessStore = defineStore(ModuleAutoBusiness, {
  state: () => ({
    ...autoBusinessStore.state,
    _config: {
      key: 'auto_business_id',
      code: 'auto_business_code',
      name: 'auto_business_name',
      table: 'di_auto_business',
      moduleName: 'Định khoản',
      quickFollow: 'active',
      defaultSort: 'ref_type_name, auto_business_code'
    },
    moduleName: 'autoBusiness',
  }),
  actions: {...autoBusinessStore.action},
  getters: {
    ...autoBusinessStore.getters,
  },
});
